// The sentinel request id that puts the OAuth consent screen into UI-only
// preview mode (`/oauth/consent?request=ui-preview`). Kept in this tiny leaf
// module — with no React/Chakra/hook imports — so both the consent page AND the
// auth guard (which must let the preview through without a session) can share
// it without the guard statically pulling in the lazy-loaded consent-page
// bundle.
export const OAUTH_CONSENT_PREVIEW_REQUEST_ID = "ui-preview";

// True when a location's path + query select the consent preview. Used by the
// auth guard to render it pre-auth. Takes the pieces (not a full location) so it
// has no router dependency.
export const isOAuthConsentPreview = (pathname: string, search: string): boolean =>
  pathname === "/oauth/consent" &&
  new URLSearchParams(search).get("request") === OAUTH_CONSENT_PREVIEW_REQUEST_ID;
